module.exports = __webpack_public_path__ + "media/admin/cs_publication_request_002_lg-b47a180b.png";